import { useState } from "react";

import { StartTrialButton } from "features/subscriptions/components";

import ManageAgencySeatsDialog from "common/components/ManageAgencySeatsDialog";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useCustomer from "common/datahooks/useCustomer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { SubscriptionType } from "common/types";

import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

export default function SubscriptionActivation({
  openManageSubscription,
}: {
  openManageSubscription: (subscriptionType: SubscriptionType) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const [subscriptionType, setSubscriptionType] =
    useState<SubscriptionType>("agency");
  const [isManageSeatsOpen, setIsManageSeatsOpen] = useState(false);

  const { subscription_status, rental_subscription_status } =
    useSelectedWorkspaceContext();

  const {
    customerInfo: { agency_subscription_status, had_trial },
  } = useCustomer();

  const isExpired =
    subscription_status === "cancelled" ||
    rental_subscription_status === "cancelled" ||
    agency_subscription_status === "cancelled";

  //if this is true, we show the manage agency seats flow instead of the manage subscription flow
  const canAssignAgencySeats =
    subscriptionType === "agency" &&
    agency_subscription_status &&
    agency_subscription_status !== "cancelled";

  let actionButton = (
    <Button
      onClick={() =>
        canAssignAgencySeats
          ? setIsManageSeatsOpen(true)
          : openManageSubscription(subscriptionType)
      }
      className="mt-auto ml-auto"
      size={isDesktop ? "md" : "lg"}
    >
      Continue
    </Button>
  );

  if (subscriptionType === "user" && !had_trial) {
    actionButton = (
      <StartTrialButton
        size={isDesktop ? "md" : "lg"}
        className="mt-auto ml-auto"
      />
    );
  }

  const Component = isDesktop ? DesktopLayout : MobileLayout;

  return (
    <>
      <Component
        title={isExpired ? "Your subscription expired" : "Active plan required"}
        subscriptionType={subscriptionType}
        setSubscriptionType={setSubscriptionType}
        actionButton={actionButton}
      />
      {canAssignAgencySeats && (
        <ManageAgencySeatsDialog
          isOpen={isManageSeatsOpen}
          setIsOpen={setIsManageSeatsOpen}
        />
      )}
    </>
  );
}
